import { StyleSheet, css } from 'aphrodite';
import { useState, useEffect } from 'react';
import axios from 'axios';

const Purchases = () => {
  const [purchases, setPurchases] = useState([]);
  const [formData, setFormData] = useState({ name: '', quantity: '', price: '', orderId: '', vendor: '', date: '' });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchPurchases();
  }, []);

  const fetchPurchases = () => {
    axios.get('/hospital/medication-purchases/')
      .then(res => setPurchases(res.data))
      .catch(err => console.error(err));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editingId) {
      axios.put(`/hospital/medication-purchases/${editingId}`, formData)
        .then(() => {
          fetchPurchases();
          setEditingId(null);
          setFormData({ name: '', quantity: '', price: '', orderId: '', vendor: '', date: '' });
        })
        .catch(err => console.error(err));
    } else {
      axios.post('/hospital/medication-purchases/', formData)
        .then(() => {
          fetchPurchases();
          setFormData({ name: '', quantity: '', price: '', orderId: '', vendor: '', date: '' });
        })
        .catch(err => console.error(err));
    }
  };

  const handleDelete = (id) => {
    axios.delete(`/hospital/medication-purchases/${id}`)
      .then(() => fetchPurchases())
      .catch(err => console.error(err));
  };

  const handleEdit = (purchase) => {
    setFormData(purchase);
    setEditingId(purchase.id);
  };

  return (
    <div className={css(styles.container)}>
      <h2>Hospital Purchase History</h2>
      <form onSubmit={handleSubmit} className={css(styles.form)}>
        <input type='text' placeholder='Medication' value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
        <input type='number' placeholder='Quantity' value={formData.quantity} onChange={(e) => setFormData({ ...formData, quantity: e.target.value })} required />
        <input type='number' placeholder='Price' value={formData.price} onChange={(e) => setFormData({ ...formData, price: e.target.value })} required />
        <input type='text' placeholder='Order ID' value={formData.orderId} onChange={(e) => setFormData({ ...formData, orderId: e.target.value })} required />
        <input type='text' placeholder='Vendor' value={formData.vendor} onChange={(e) => setFormData({ ...formData, vendor: e.target.value })} required />
        <input type='date' value={formData.date} onChange={(e) => setFormData({ ...formData, date: e.target.value })} required />
        <button type='submit'>{editingId ? 'Update' : 'Add'} Purchase</button>
      </form>
      <table className={css(styles.table)}>
        <thead>
          <tr>
            <th>Medication</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Order ID</th>
            <th>Vendor</th>
            <th>Purchase Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {purchases.map((purchase) => (
            <tr key={purchase.id}>
              <td>{purchase.name}</td>
              <td>{purchase.quantity}</td>
              <td>{purchase.price}</td>
              <td>{purchase.orderId}</td>
              <td>{purchase.vendor}</td>
              <td>{purchase.date}</td>
              <td>
                <button onClick={() => handleEdit(purchase)}>Edit</button>
                <button onClick={() => handleDelete(purchase.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    marginLeft: '260px',
    padding: '20px'
  },
  form: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    backgroundColor: '#fff',
    'th, td': {
      padding: '10px',
      border: '1px solid #ccc'
    },
    th: {
      backgroundColor: '#3498db',
      color: '#fff'
    }
  }
});

export default Purchases;
